import { render } from "./OTP.vue?vue&type=template&id=65b8b3c8&scoped=true"
import script from "./OTP.vue?vue&type=script&lang=js"
export * from "./OTP.vue?vue&type=script&lang=js"

import "./OTP.vue?vue&type=style&index=0&id=65b8b3c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b8b3c8"]])

export default __exports__